<template>
    <div class="flex flex-col items-center flex-grow mt-10">
        <div
            class="max-w-2xl w-full bg-white px-6 py-4 rounded-md ring-1 ring-border shadow user-written-body"
            v-html="terms"
        />
    </div>
</template>

<script>
import LandingPageLayout from '@/Layouts/LandingPageLayout.vue'
export default {
    layout: LandingPageLayout,
    props: {
        terms: {
            type: String,
            required: true,
        },
    },
}
</script>
